define(function(require, exports, module) {
    'use strict';
    // core file
    // "product" field was added

    var AuthManager = require('managers/auth.manager');

    module.exports = AuthManager.extend({
        formatContactPreferences: function(subscriptions = {}) {
            const contactPreferences = [];
            const supportedChannels = [
                'SMS',
                'email',
                'phone',
                'directMail',
                'mobilePush',
                'internalMessage',
                'desktopCompanion'
            ];
            const allChannels = Object.values(subscriptions).reduce((acc, subscription) => {
                if (subscription.channel === 'all') {
                    acc.push(subscription);
                }

                return acc;
            }, []);

            if (allChannels.length) {
                allChannels.forEach(channel => {
                    supportedChannels.forEach(name => {
                        contactPreferences.push({
                            channel: name,
                            type: channel.type,
                            preference: channel.preference,
                            product: channel.product
                        });
                    });
                });
            }

            for (const key in subscriptions) {
                const subscription = subscriptions[key];

                if (subscription.channel !== 'all') {
                    const overridePref = contactPreferences.find(pref =>
                        pref.channel === subscription.channel && pref.type === subscription.type && pref.product === subscription.product
                    );

                    if (overridePref) {
                        overridePref.preference = subscription.preference;
                    } else {
                        subscription.type.split(',').forEach(type => {
                            contactPreferences.push({ ...subscription, type: type.trim() });
                        });
                    }
                }
            }

            return contactPreferences;
        }
    });
});
